$('.js-promoAnimationLink').on('mouseenter', function() {
	const _this = $(this);
	const currentIndex = Number(_this.data('index'));
	const currentTab = _this.data('tab');

	$('.js-promoAnimationLink').removeClass('is_active');

	_this.addClass('is_active');

	// _this.parents('.js-promoAnimation').find('.js-promoAnimationElem').eq(currentIndex).addClass('is_show').siblings().removeClass('is_show');
	_this.parents('.js-promoAnimation').addClass('items_show');
	_this.parents('.js-promoAnimation').find(`#${currentTab}`).addClass('is-active')
});

$('.js-promoAnimationLink').on('mouseleave', function() {
	// $('.js-promoAnimationElem').removeClass('is_show');
	$('.js-promoAnimation').removeClass('items_show');
	$('.tab-block').removeClass('is-active');
});

if (document.querySelector('.js-slides')) {
	const slides = document.querySelectorAll('.js-slides');

	slides.forEach(elem => {
		function addCloneItem(item) {
			elem.appendChild(item.cloneNode(true));
			item.classList.add('is-animate');
		}
		
		function addTransform() {
			elem.classList.add('is-transform');
			addCloneItem(elem.querySelector('.slides-item:first-child'));
			setTimeout(() => {
				elem.classList.remove('is-transform');
				elem.querySelector('.slides-item:first-child').remove();
				elem.querySelector('.is-animate')?.classList.remove('is-animate');
				requestAnimationFrame(() => {
					setTimeout(addTransform, 1000);
				});
			}, 1000);
		}
		
		requestAnimationFrame(() => {
			setTimeout(addTransform, 1000);
		});
	})
}